/**
 * Branding Fragment
 * Handles the upload-page receiver lookup mode, whose four radios decide
 * which of the two dependent controls the form shows or enables.
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Branding Handlers
// ============================================================================

const BrandingHandlers = {
    /**
     * Reveal the directory list for DIRECTORY, enable the default-receiver
     * select for DEFAULT_RECEIVER, and hide or disable them otherwise. Each
     * radio used to carry its own copy of both assignments.
     */
    onReceiverLookupMode(e, element) {
        const directory = document.getElementById('directory-section');
        const defaultOid = document.getElementById('defaultOid');
        if (directory) {
            directory.style.display = element.value === 'DIRECTORY' ? 'block' : 'none';
        }
        if (defaultOid) {
            defaultOid.disabled = element.value !== 'DEFAULT_RECEIVER';
        }
    },
};

// ============================================================================
// Initialization
// ============================================================================

export function initBranding() {
    if (initialized) return;
    initialized = true;

    Events.on('click', 'receiver-lookup-mode', BrandingHandlers.onReceiverLookupMode);

    console.log('[LeapFILE] Branding fragment initialized');
}
